import axios from 'axios'

import { fetchWithAxiosHeaders } from '@/plugins/axios.js'
import type { AIAssistantQuestionType } from '@/types/ai-assistant'

export default {
  getConversations () {
    return axios.get('/conversations')
  },
  getConversationMessages (conversationId: string) {
    return axios.get(`/conversations/${conversationId}/messages`)
  },
  postPrompt (
    mnemo: string,
    prompt: string,
    conversationId: string | null,
    questionType: AIAssistantQuestionType | null,
  ) {
    return axios.post(`/room/${mnemo}/ai-ask`, { prompt, conversationId, questionType })
  },
  async postStreamedPrompt (
    mnemo: string,
    prompt: string,
    conversationId: string | null,
    questionType: AIAssistantQuestionType | null,
    messageId: string | null = null,
    retry: boolean = false,
  ) {
    const url = retry
      ? `/room/${mnemo}/ai-ask-retry/${messageId}`
      : `/room/${mnemo}/ai-ask-stream`

    return fetchWithAxiosHeaders(url, { prompt, conversationId, questionType })
  },
  async postStreamedDocPrompt (
    mnemo: string,
    prompt: string,
    conversationId: string | null,
    fileIds: number[] = [],
  ) {
    const url = `/room/${mnemo}/ai-ask-doc`

    return fetchWithAxiosHeaders(url, {
      prompt,
      fileIds,
      conversationId,
      type: 'ASK_DOC',
    })
  },
}
